import { NgModule, ApplicationRef } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
// Ezio: IMPORTANT: removed BrowserAnimation beacuse while routing from a component to another it didn't destroy the provious component if the page was in error!!!
// import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { HttpClientModule } from '@angular/common/http';
// import { HttpClientModule } from '@angular/common/http';

/*
 * Platform and Environment providers/directives/pipes
 */
import { routing } from './app.routing';
// App is our top level component
import { AppComponent } from './app.component';
//import { APP_RESOLVER_PROVIDERS } from './app.resolver';
import { AppState, InternalStateType } from './app.service';

// Core providers
//import {SmartAdminCoreModule} from "./core/core.module";
import { SmartAdminCoreModule } from './smartadmin-core/smartadmin-core.module';
import { SmartadminLayoutModule } from './shared/layout/layout.module';
import { WebcamModule } from 'ngx-webcam';

// Custom providers
import {
  AUTH_PROVIDER,
  AUTH_GUARD_PROVIDER,
  MASTERDATA_PROVIDER,
  CORE_PROVIDER,
  ORDERS_PROVIDER,
  GARMENT_WIZARD_PROVIDER_MOCK,
  TOKEN_INTERCEPTOR,
  GARMENT_WIZARD_PROVIDER,
  COMMON_PROVIDER,
  ORDER_WIZARD_PROVIDER
} from './provider-list.config';
import { CustomerTileComponent } from './+master-data/customers/customer-tile.component';
// import { AUTH_PROVIDER_MOCK, MASTERDATA_PROVIDER_MOCK, CORE_PROVIDER_MOCK } from './provider-list.config'

// Application wide providers
const APP_PROVIDERS = [
  //...APP_RESOLVER_PROVIDERS,
  AppState
];

type StoreType = {
  state: InternalStateType;
  restoreInputValues: () => void;
  disposeOldHosts: () => void;
};

/**
 * `AppModule` is the main entry point into Angular2's bootstraping process
 */
@NgModule({
  bootstrap: [AppComponent],
  declarations: [AppComponent],
  imports: [
    // import Angular's modules
    BrowserModule,
    // BrowserAnimationsModule,
    FormsModule,
    HttpModule,
    HttpClientModule,
    // HttpClientModule,
    SmartAdminCoreModule,
    SmartadminLayoutModule,
    //WebcamModule,
    routing
  ],
  providers: [
    // expose our Services and Providers into Angular's dependency injection
    // ENV_PROVIDERS,
    APP_PROVIDERS,
    AUTH_PROVIDER,
    AUTH_GUARD_PROVIDER,
    MASTERDATA_PROVIDER,
    CORE_PROVIDER,
    ORDERS_PROVIDER,
    GARMENT_WIZARD_PROVIDER_MOCK,
    COMMON_PROVIDER,
    TOKEN_INTERCEPTOR,
    ORDER_WIZARD_PROVIDER
  ]
})
export class AppModule {
  constructor(public appRef: ApplicationRef, public appState: AppState) {}
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts